import React, { useState } from 'react';
import { Alert, Form, Input, Button, message } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AuthLayout from '../components/AuthLayout';

const Register = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();
  const onFinish = async ({ confirmPassword, ...values }) => {
    setLoading(true);
    setError('');
    try {
      const result = await register(values);
      if (result.success) {
        message.success('账号已开通，请登录');
        navigate('/login', { replace: true });
      } else setError(result.message || '开通失败，请核对邀请码。');
    } catch (failure) {
      setError(failure.message || '暂时无法开通，请稍后重试。');
    } finally {
      setLoading(false);
    }
  };
  return (
    <AuthLayout
      title="受邀开通账号"
      description="请先向业务对接人获取邀请码，再填写以下信息。"
    >
      {error && (
        <Alert className="inline-error" type="error" showIcon message={error} />
      )}
      <Form
        layout="vertical"
        onFinish={onFinish}
        requiredMark={false}
        disabled={loading}
      >
        <Form.Item
          label="邀请码"
          name="invitationCode"
          rules={[
            {
              required: true,
              whitespace: true,
              message: '请输入业务对接人提供的邀请码',
            },
          ]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="用户名"
          name="username"
          extra="4–20 个字符"
          rules={[
            { required: true, whitespace: true, message: '请输入用户名' },
            { min: 4, max: 20, message: '用户名需为 4–20 个字符' },
          ]}
        >
          <Input autoComplete="username" />
        </Form.Item>
        <Form.Item
          label="密码"
          name="password"
          extra="6–20 个字符"
          rules={[
            { required: true, message: '请输入密码' },
            { min: 6, max: 20, message: '密码需为 6–20 个字符' },
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          label="确认密码"
          name="confirmPassword"
          dependencies={['password']}
          rules={[
            { required: true, message: '请再次输入密码' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                return !value || value === getFieldValue('password')
                  ? Promise.resolve()
                  : Promise.reject(new Error('两次输入的密码不一致'));
              },
            }),
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <details className="auth-optional">
          <summary>补充联系方式（选填）</summary>
          <Form.Item
            label="邮箱"
            name="email"
            rules={[{ type: 'email', message: '请输入有效的邮箱地址' }]}
          >
            <Input autoComplete="email" />
          </Form.Item>
          <Form.Item label="手机号" name="phone">
            <Input autoComplete="tel" />
          </Form.Item>
        </details>
        <Button
          className="auth-submit"
          type="primary"
          htmlType="submit"
          block
          loading={loading}
        >
          开通账号
        </Button>
      </Form>
      <p className="auth-switch">
        已有账号？ <Link to="/login">返回登录</Link>
      </p>
    </AuthLayout>
  );
};
export default Register;
